import axios from "axios";
import supabase from "supabaseClient.js";
//var Profile_base_URL = "https://tanyapendeta.online/user/api/email";
//var Update_base_URL = "https://tanyapendeta.online/user/api/update";
// Define external endpoints if used elsewhere in the app
const Personal_Profile_base_URL =
  "https://tanyapendeta.online/user/api/emailProfile";
const Picture_base_URL = "https://tanyapendeta.online/user/api/upload";

export class Profile_sending {
  async personal_profile_taker(Item) {
    try {
      const response = await axios.post(Personal_Profile_base_URL, Item);
      if (response.status === 201) {
        const createdPrayer = response.data;
        console.log("New Prayer ID:", createdPrayer.id);
        return response;
      } else {
        console.log(
          "Error personal_profile_taker User. Status code:",
          response.status
        );
        return response;
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response && error.response.status === 400) {
        console.log("Error Finding User. Status code:", error.response.status);
        return error.response.status;
      }
    }
  }

  async profile_taker(Item) {
    try {
      const { data, error, status } = await supabase
        .from("users")
        .select("*")
        .eq("UserName", Item.userName);

      if (error && status !== 406) {
        throw error;
      }

      if (data) {
        console.log("User Data:", data);
        return data;
      } else {
        console.log("Error Finding User. Status code:", status);
        return null;
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.status === 400) {
        console.log("Error Finding User. Status code:", error.status);
        return error.status;
      }
    }
  }

  async Update_profile(Item) {
    try {
      const { data, error } = await supabase
        .from("users")
        .update({
          UserName: Item.firstName,
          email: Item.userEmail,
          UserIntroduction: Item.userHighlight,
          UserParagraph: Item.userParagraph,
          BibleVerse: Item.bibleVerse,
          UserCountry: Item.userLocation,
          userSocialmedia: Item.userSocialmedia,
        })
        .eq("UserName", Item.userName);

      if (error) {
        console.log("User not updated successfully:", error);
        throw error;
      }

      if (data) {
        console.log("User updated successfully:", data);
        return data;
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response && error.response.status === 400) {
        console.log("Error Finding User. Status code:", error.response.status);
        return error.response.status;
      }
    }
  }

  async Update_ProfileNotChristian(Item) {
    console.log(Item);
    console.log("what is there");
    try {
      const { data: profile_data, error: profile_error } = await supabase
        .from("users")
        .update({
          UserName: Item.UserName,
          email: Item.userEmail,
          UserIntroduction: Item.userHighlight,
          UserParagraph: Item.userParagraph,
          UserQuotes: Item.UserQuotes,
          UserCountry: Item.userLocation,
        })
        .eq("UserName", Item.UserName);
      if (profile_error) {
        // Handle the error
        console.error("Error updating profile:", profile_error);
        // Optionally, you could throw an error or return a specific response
        throw false;
      } else {
        // Successfully updated the profile
        console.log("successfully updating profile:", profile_data);
        return true;
      }
    } catch (error) {
      // Catch any unexpected errors
      console.log("Unexpected error:", error);
      // Handle the error (e.g., show a notification, log the error, etc.)
      throw false;
    }
  }

  async Profile_Sending(Item, name) {
    try {
      const response = await axios.post(
        Picture_base_URL + "?param=" + encodeURIComponent(name),
        Item
      );
      if (response.status === 201) {
        const createdPrayer = response.data;
        console.log("New Prayer ID:", createdPrayer.id);
        return response.status;
      } else {
        console.log("Error creating prayer. Status code:", response.status);
        return response.status;
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response && error.response.status === 400) {
        console.log(
          "Error creating prayer. Status code:",
          error.response.status
        );
        return error.response.status;
      }
    }
  }

  dataURLtoBlob(dataUrl) {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  async uploadBackgoundImage(file, filePath) {
    const blob = this.dataURLtoBlob(file);
    console.log(blob);
    console.log("what is this");
    console.log(file);
    var bucketName = "tanyapendeta bucket";
    try {
      const { data: exists } = await supabase.storage
        .from(bucketName)
        .exists(filePath);
      console.log("what".concat(filePath));
      console.log(exists);
      if (exists) {
        const { error: removeError } = await supabase.storage
          .from(bucketName)
          .remove([filePath]);

        if (removeError) {
          console.error("Error deleting existing file:", removeError);
          return null;
        }
      }

      const { data, error } = await supabase.storage
        .from(bucketName)
        .upload(filePath, blob, { cacheControl: "3600", upsert: false });

      if (error) {
        console.error("Error uploading image:", error);
        return null;
      }

      return 200;
    } catch (error) {
      console.error("An unexpected error occurred:", error);
      return null;
    }
  }

  async uploadProfileImage(file, filePath) {
    const blob = this.dataURLtoBlob(file);
    var bucketName = "tanyapendeta bucket";
    try {
      const { data: exists } = await supabase.storage
        .from(bucketName)
        .exists(filePath);
      console.log("what".concat(filePath));
      console.log(exists);
      if (exists) {
        const { error: removeError, success: hi } = await supabase.storage
          .from(bucketName)
          .remove([filePath]);

        if (removeError) {
          console.error("Error deleting existing file:", removeError);
          return null;
        } else {
          const { data, error } = await supabase.storage
            .from(bucketName)
            .upload(filePath, blob, { cacheControl: "3600", upsert: false });

          if (error) {
            console.error("Error uploading image:", error);
            return null;
          }

          return 200;
        }
      } else {
        const { data, error } = await supabase.storage
          .from(bucketName)
          .upload(filePath, blob, { cacheControl: "3600", upsert: false });

        if (error) {
          console.error("Error uploading image:", error);
          return null;
        }

        return 200;
      }
    } catch (err) {
      console.error("An unexpected error occurred:", err);
      return null;
    }
  }
}

export default new Profile_sending();
